// client/src/services/contentApprovalApi.js
// On-Screen 2.0 social content approval workflow. Talks to the routes added
// to server/routes/scheduledPostRoutes.js.

import { getJson, postJson, putJson } from './http';

const base = '/api/schedule';

/** Move a draft / changes-requested post into review. */
export const submitForReview = (postId, note) =>
  postJson(`${base}/${Number(postId)}/submit`, { note });

/** Approve an in-review post (manager+). */
export const approvePost = (postId, note) =>
  postJson(`${base}/${Number(postId)}/approve`, { note });

/** Send an in-review post back for changes (manager+). */
export const requestChanges = (postId, note) =>
  postJson(`${base}/${Number(postId)}/request-changes`, { note });

/** Reject an in-review post (manager+). */
export const rejectPost = (postId, note) =>
  postJson(`${base}/${Number(postId)}/reject`, { note });

/** Full review history for a post. */
export const getReviewHistory = (postId) =>
  getJson(`${base}/${Number(postId)}/reviews`);

/**
 * Edit a scheduled post's content / media / schedule / campaign link.
 * If the post was already approved and the content changed, the server
 * auto-reopens it to 'changes_requested' (reopened: true in the response).
 */
export const editScheduledPost = (postId, payload) =>
  putJson(`${base}/${Number(postId)}`, payload);

export const APPROVAL_STAGES = [
  'idea', 'draft', 'in_review', 'changes_requested', 'approved', 'rejected', 'archived',
];

export const APPROVAL_LABELS = {
  idea: 'Idea',
  draft: 'Draft',
  in_review: 'In review',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  rejected: 'Rejected',
  archived: 'Archived',
};
